import { useState } from 'react';
import { NewsletterClient, NewsletterDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useNewsletterApi = () => {
    const apiClient = new NewsletterClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: NewsletterDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createNewsletter(data);
        } catch (err: any) {
            setError(err.message || 'Error creating Newsletter');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: NewsletterDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateNewsletter(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating Newsletter');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getNewsletterById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching Newsletter');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchNewsletters(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching Newsletters');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteNewsletter(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting Newsletter');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};